export default [
  {
    "DisplayName": "全部构件",
    "Id": "",
    "Children": [
      {
        "DisplayName": "常规模型",
        "Id": "",
        "Children": [
          {
            "DisplayName": "模型文字",
            "Id": "",
            "Children": [
              {
                "DisplayName": "big",
                "Id": "02.95010b4c0753df5d.155627",
                "Children": []
              },
              {
                "DisplayName": "big",
                "Id": "02.95010b4c0753df5d.155649",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "窗",
        "Id": "",
        "Children": [
          {
            "DisplayName": "Fixed",
            "Id": "",
            "Children": [
              {
                "DisplayName": "36\" x 48\"",
                "Id": "02.95010b4c0753df5d.213784",
                "Children": []
              },
              {
                "DisplayName": "36\" x 48\"",
                "Id": "02.95010b4c0753df5d.213744",
                "Children": []
              },
              {
                "DisplayName": "36\" x 48\"",
                "Id": "02.95010b4c0753df5d.213904",
                "Children": []
              },
              {
                "DisplayName": "36\" x 48\"",
                "Id": "02.95010b4c0753df5d.213829",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "地形",
        "Id": "",
        "Children": [
          {
            "DisplayName": "@",
            "Id": "",
            "Children": [
              {
                "DisplayName": "@",
                "Id": "02.95010b4c0753df5d.156484",
                "Children": []
              },
              {
                "DisplayName": "@",
                "Id": "02.95010b4c0753df5d.156624",
                "Children": []
              },
              {
                "DisplayName": "@",
                "Id": "02.95010b4c0753df5d.228245",
                "Children": []
              },
              {
                "DisplayName": "@",
                "Id": "02.95010b4c0753df5d.157834",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "环境",
        "Id": "",
        "Children": [
          {
            "DisplayName": "RPC Beetle",
            "Id": "",
            "Children": [
              {
                "DisplayName": "RPC Beetle",
                "Id": "02.95010b4c0753df5d.160975",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Semi Truck",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Semi Truck",
                "Id": "02.95010b4c0753df5d.162489",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Van",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Delivery Van",
                "Id": "02.95010b4c0753df5d.162697",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "建筑地坪",
        "Id": "",
        "Children": [
          {
            "DisplayName": "建筑地坪",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Building Pad",
                "Id": "02.95010b4c0753df5d.156625",
                "Children": []
              },
              {
                "DisplayName": "Road",
                "Id": "02.95010b4c0753df5d.157835",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "结构柱",
        "Id": "",
        "Children": [
          {
            "DisplayName": "HSS-Hollow Structural Section-Column",
            "Id": "",
            "Children": [
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183010",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183004",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182964",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182986",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182960",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182954",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182982",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182946",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183014",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182972",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183000",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182974",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182952",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182988",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183020",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182944",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182968",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182992",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182966",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183016",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182978",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182970",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182958",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183018",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182980",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183006",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182956",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.182976",
                "Children": []
              },
              {
                "DisplayName": "HSS4X4X1/4",
                "Id": "02.95010b4c0753df5d.183024",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "栏杆扶手",
        "Id": "",
        "Children": [
          {
            "DisplayName": "栏杆扶手",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Guardrail - Pipe",
                "Id": "02.95010b4c0753df5d.214861",
                "Children": []
              },
              {
                "DisplayName": "Guardrail - Pipe",
                "Id": "02.95010b4c0753df5d.214865",
                "Children": []
              },
              {
                "DisplayName": "Guardrail - Pipe",
                "Id": "02.95010b4c0753df5d.214980",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "楼板",
        "Id": "",
        "Children": [
          {
            "DisplayName": "楼板",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Floor Slab - 4\"",
                "Id": "02.95010b4c0753df5d.216070",
                "Children": []
              },
              {
                "DisplayName": "Mezzanine Floor",
                "Id": "02.95010b4c0753df5d.214463",
                "Children": []
              },
              {
                "DisplayName": "Ramp - 12\"",
                "Id": "02.95010b4c0753df5d.195002",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "楼板边缘",
        "Id": "",
        "Children": [
          {
            "DisplayName": "楼板边缘",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Thickened 24\" x 12\"",
                "Id": "02.95010b4c0753df5d.216624",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "楼梯",
        "Id": "",
        "Children": [
          {
            "DisplayName": "组合楼梯",
            "Id": "",
            "Children": [
              {
                "DisplayName": "7\" max riser 11\" tread",
                "Id": "02.95010b4c0753df5d.214608",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "门",
        "Id": "",
        "Children": [
          {
            "DisplayName": "Curtain Wall Sgl Glass",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Curtain Wall Sgl Glass",
                "Id": "02.95010b4c0753df5d.191880",
                "Children": []
              },
              {
                "DisplayName": "Curtain Wall Sgl Glass",
                "Id": "02.95010b4c0753df5d.191870",
                "Children": []
              },
              {
                "DisplayName": "Curtain Wall Sgl Glass",
                "Id": "02.95010b4c0753df5d.191882",
                "Children": []
              },
              {
                "DisplayName": "Curtain Wall Sgl Glass",
                "Id": "02.95010b4c0753df5d.191872",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Double-Flush-Dbl Acting",
            "Id": "",
            "Children": [
              {
                "DisplayName": "72\" x 84\"",
                "Id": "02.95010b4c0753df5d.191186",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "OHD_WPADS_2491",
            "Id": "",
            "Children": [
              {
                "DisplayName": "8' x 6'-6\"",
                "Id": "02.95010b4c0753df5d.185484",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Single-Flush",
            "Id": "",
            "Children": [
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.188718",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.184978",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.189276",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.188685",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.184751",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\"",
                "Id": "02.95010b4c0753df5d.192384",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\" 20Min",
                "Id": "02.95010b4c0753df5d.189174",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\" 20Min",
                "Id": "02.95010b4c0753df5d.189130",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\" 20Min",
                "Id": "02.95010b4c0753df5d.189307",
                "Children": []
              },
              {
                "DisplayName": "36\" x 84\" 20Min",
                "Id": "02.95010b4c0753df5d.190346",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "幕墙嵌板",
        "Id": "",
        "Children": [
          {
            "DisplayName": "System Panel",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150524",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150615",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150577",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191874",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149654",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191891",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150527",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191886",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191890",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191651",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152079",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191900",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191648",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150569",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191634",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150579",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191625",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150580",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150520",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152115",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191615",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150525",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150518",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191898",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191894",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191618",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152156",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191899",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150516",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150575",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191859",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191652",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152075",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191630",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191654",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191642",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150614",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149658",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152117",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191639",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150608",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152158",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191628",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150616",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191633",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150573",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150571",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191888",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150522",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152153",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150526",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152113",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191895",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191897",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191901",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152077",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149665",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150610",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152149",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191902",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152111",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191655",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150606",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152157",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149664",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191643",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191621",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150617",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191622",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191649",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152155",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191631",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191637",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191878",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149662",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152084",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191866",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152147",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152085",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152081",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191624",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152151",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149656",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191627",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191876",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191896",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152120",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191646",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149650",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152119",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191640",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150578",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191892",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191619",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152083",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191868",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191616",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152122",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.150612",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191645",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191636",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191893",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152121",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.191884",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.149663",
                "Children": []
              },
              {
                "DisplayName": "Glazed",
                "Id": "02.95010b4c0753df5d.152086",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "幕墙竖梃",
        "Id": "",
        "Children": [
          {
            "DisplayName": "Rectangular Mullion",
            "Id": "",
            "Children": [
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191949",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152135",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150597",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191736",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191766",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191915",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150591",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149670",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152167",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149669",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191783",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149671",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150629",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191787",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191722",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191731",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191753",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191764",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191914",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191924",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191721",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152176",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191742",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150630",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152104",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191759",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152169",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191973",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191945",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152098",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191951",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150590",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150601",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152159",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191789",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191757",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150541",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150598",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152142",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191936",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152136",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152102",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152143",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191916",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150602",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191741",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149686",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152180",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152087",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191775",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191946",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191745",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150637",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152137",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191967",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152177",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191782",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191969",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191913",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191723",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149679",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191765",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191730",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191966",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152089",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150539",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150549",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191768",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191726",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191962",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191920",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191743",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191963",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191739",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191786",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150528",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152144",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150544",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150638",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191861",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152141",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191773",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149672",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191944",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150582",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191958",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152173",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152161",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149683",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191974",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150599",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191956",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152175",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152101",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150592",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152123",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150635",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152106",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152125",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152134",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152179",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191746",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191749",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149685",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150581",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191947",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152108",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191732",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191937",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150621",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191724",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191943",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150633",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191752",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191780",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152168",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191971",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150594",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152096",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150536",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150548",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191744",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150531",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152139",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152097",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150540",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152105",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150584",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150538",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191727",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191760",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191778",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191919",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191767",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191774",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152099",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152133",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191729",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191952",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191790",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191748",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150596",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191762",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149681",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152172",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152138",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191922",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152103",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191959",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191930",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149688",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191763",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191961",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152088",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152124",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150626",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152162",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150595",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149682",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150546",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191940",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191755",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150627",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191785",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191965",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191948",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150631",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191772",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150530",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150545",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191734",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191751",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191950",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149693",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150628",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150636",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191970",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191954",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191770",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152140",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150543",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150529",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191953",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191756",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191862",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149689",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191735",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152160",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191938",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149690",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149694",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191941",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150547",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150634",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191788",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152126",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191740",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191939",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150542",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152132",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191777",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191964",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191781",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191864",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191747",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191738",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150583",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191784",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191942",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191750",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191754",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191769",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150593",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191918",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150589",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191863",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191972",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150632",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191761",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150619",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191776",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152178",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191733",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150618",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150600",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191779",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149692",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191934",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191935",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152170",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191929",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191725",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191968",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191975",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191917",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150537",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191925",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152171",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152107",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152090",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191926",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152174",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191728",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149684",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152095",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191923",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150639",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191771",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191931",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152131",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.152100",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191737",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191758",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.149680",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191921",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.191957",
                "Children": []
              },
              {
                "DisplayName": "2.5\" x 5\" rectangular",
                "Id": "02.95010b4c0753df5d.150620",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.149675",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.149674",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150624",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150585",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150623",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150622",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152128",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150533",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.149677",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152129",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152165",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150532",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150587",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152130",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150535",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152091",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152092",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150625",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152093",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150586",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152094",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150534",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152164",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152127",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152166",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.150588",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.149676",
                "Children": []
              },
              {
                "DisplayName": "Tall Mullion",
                "Id": "02.95010b4c0753df5d.152163",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "墙",
        "Id": "",
        "Children": [
          {
            "DisplayName": "基本墙",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152352",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146898",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152373",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151276",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148023",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146844",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151950",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152359",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151211",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151371",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151971",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151964",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148081",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152366",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151337",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146778",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148624",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151957",
                "Children": []
              },
              {
                "DisplayName": "Exterior - Brick on Mtl. Stud - No Cap",
                "Id": "02.95010b4c0753df5d.163895",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU",
                "Id": "02.95010b4c0753df5d.194659",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU",
                "Id": "02.95010b4c0753df5d.195267",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU",
                "Id": "02.95010b4c0753df5d.195200",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151970",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151963",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146897",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151956",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146843",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151210",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152365",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151336",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151949",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152358",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151370",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148623",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152351",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148080",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.146777",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.152372",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.148022",
                "Children": []
              },
              {
                "DisplayName": "Exterior - CMU on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.151275",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Roof Wall",
                "Id": "02.95010b4c0753df5d.179262",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Roof Wall",
                "Id": "02.95010b4c0753df5d.179615",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Wall",
                "Id": "02.95010b4c0753df5d.177551",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Wall",
                "Id": "02.95010b4c0753df5d.177816",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Wall",
                "Id": "02.95010b4c0753df5d.177653",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Canopy Wall",
                "Id": "02.95010b4c0753df5d.177757",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Details",
                "Id": "02.95010b4c0753df5d.178323",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Details",
                "Id": "02.95010b4c0753df5d.178461",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Details",
                "Id": "02.95010b4c0753df5d.178208",
                "Children": []
              },
              {
                "DisplayName": "Exterior - EIFS Details",
                "Id": "02.95010b4c0753df5d.178416",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.190008",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.205054",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.188548",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.190558",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.190322",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.205184",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.188946",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.189068",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.188460",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.188547",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.190258",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.188546",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.190515",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition (1-hr)",
                "Id": "02.95010b4c0753df5d.185622",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition (1-hr)",
                "Id": "02.95010b4c0753df5d.183777",
                "Children": []
              },
              {
                "DisplayName": "Interior - 5 1/2\" Partition (1-hr)",
                "Id": "02.95010b4c0753df5d.204942",
                "Children": []
              },
              {
                "DisplayName": "Interior - 7 1/2\" Partition",
                "Id": "02.95010b4c0753df5d.186535",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "梯段",
        "Id": "",
        "Children": [
          {
            "DisplayName": "非整体梯段",
            "Id": "",
            "Children": [
              {
                "DisplayName": "2\" Tread 1\" Nosing 1/4\" Riser",
                "Id": "02.95010b4c0753df5d.214841",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "天花板",
        "Id": "",
        "Children": [
          {
            "DisplayName": "复合天花板",
            "Id": "",
            "Children": [
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.190424",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.189876",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.189893",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.191274",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.189884",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.184141",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.189868",
                "Children": []
              },
              {
                "DisplayName": "24\" x 24\" ACT.",
                "Id": "02.95010b4c0753df5d.189747",
                "Children": []
              },
              {
                "DisplayName": "GWB on Mtl. Stud",
                "Id": "02.95010b4c0753df5d.155271",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "停车场",
        "Id": "",
        "Children": [
          {
            "DisplayName": "Parking Space",
            "Id": "",
            "Children": [
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170923",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170620",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170357",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170567",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.171256",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170919",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170920",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.171154",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.171103",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.171205",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170921",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170673",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170726",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.170922",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' - 90 deg",
                "Id": "02.95010b4c0753df5d.171052",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Parking Space - ADA",
            "Id": "",
            "Children": [
              {
                "DisplayName": "9' x 18' (8' Aisle)",
                "Id": "02.95010b4c0753df5d.170179",
                "Children": []
              },
              {
                "DisplayName": "9' x 18' (8' Aisle)",
                "Id": "02.95010b4c0753df5d.170918",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "卫浴装置",
        "Id": "",
        "Children": [
          {
            "DisplayName": "American Standard - Wheelchair Users Lavatory - 9140.013",
            "Id": "",
            "Children": [
              {
                "DisplayName": "American Standard - Wheelchair Users Lavatory - 9140.013",
                "Id": "02.95010b4c0753df5d.188544",
                "Children": []
              },
              {
                "DisplayName": "American Standard - Wheelchair Users Lavatory - 9140.013",
                "Id": "02.95010b4c0753df5d.187766",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Toilet-Commercial-Wall-3D",
            "Id": "",
            "Children": [
              {
                "DisplayName": "15\" Seat Height",
                "Id": "02.95010b4c0753df5d.188542",
                "Children": []
              },
              {
                "DisplayName": "15\" Seat Height",
                "Id": "02.95010b4c0753df5d.186475",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "屋顶",
        "Id": "",
        "Children": [
          {
            "DisplayName": "基本屋顶",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Canopy Roof",
                "Id": "02.95010b4c0753df5d.155712",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "支撑",
        "Id": "",
        "Children": [
          {
            "DisplayName": "梯边梁",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Stringer - 2\" Width",
                "Id": "02.95010b4c0753df5d.214843",
                "Children": []
              },
              {
                "DisplayName": "Stringer - 2\" Width",
                "Id": "02.95010b4c0753df5d.214844",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "植物",
        "Id": "",
        "Children": [
          {
            "DisplayName": "RPC Tree - Deciduous",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.163334",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165421",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165207",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165463",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165101",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165251",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165289",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.227833",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.227869",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.163426",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.227860",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.163042",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.164883",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.227851",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.163176",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.164937",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165339",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165083",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.165153",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.227842",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.164985",
                "Children": []
              },
              {
                "DisplayName": "Lombardy Poplar - 40'",
                "Id": "02.95010b4c0753df5d.163260",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "柱",
        "Id": "",
        "Children": [
          {
            "DisplayName": "Rectangular Column",
            "Id": "",
            "Children": [
              {
                "DisplayName": "32\" x 32\"",
                "Id": "02.95010b4c0753df5d.176918",
                "Children": []
              },
              {
                "DisplayName": "32\" x 32\"",
                "Id": "02.95010b4c0753df5d.176884",
                "Children": []
              },
              {
                "DisplayName": "32\" x 32\"",
                "Id": "02.95010b4c0753df5d.176226",
                "Children": []
              },
              {
                "DisplayName": "32\" x 32\"",
                "Id": "02.95010b4c0753df5d.176856",
                "Children": []
              },
              {
                "DisplayName": "32\" x 32\"",
                "Id": "02.95010b4c0753df5d.176943",
                "Children": []
              }
            ]
          }
        ]
      },
      {
        "DisplayName": "专用设备",
        "Id": "",
        "Children": [
          {
            "DisplayName": "832_Grab_Bars",
            "Id": "",
            "Children": [
              {
                "DisplayName": "8320-001360",
                "Id": "02.95010b4c0753df5d.204601",
                "Children": []
              },
              {
                "DisplayName": "8320-001360",
                "Id": "02.95010b4c0753df5d.198988",
                "Children": []
              },
              {
                "DisplayName": "8320-001420",
                "Id": "02.95010b4c0753df5d.199092",
                "Children": []
              },
              {
                "DisplayName": "8320-001420",
                "Id": "02.95010b4c0753df5d.204602",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Bradley-Washroom_Accessories-Mirrors-740_Custom",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Bradley-Washroom_Accessories-Mirrors-740_Custom",
                "Id": "02.95010b4c0753df5d.204274",
                "Children": []
              },
              {
                "DisplayName": "Bradley-Washroom_Accessories-Mirrors-740_Custom",
                "Id": "02.95010b4c0753df5d.204604",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Bradley-Washroom_Accessories-Towel_Dispensers-252",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Bradley-Washroom_Accessories-Towel_Dispensers-252",
                "Id": "02.95010b4c0753df5d.204606",
                "Children": []
              },
              {
                "DisplayName": "Bradley-Washroom_Accessories-Towel_Dispensers-252",
                "Id": "02.95010b4c0753df5d.204458",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Security_Accessories-Bradley-SA12",
            "Id": "",
            "Children": [
              {
                "DisplayName": "SA12",
                "Id": "02.95010b4c0753df5d.203952",
                "Children": []
              },
              {
                "DisplayName": "SA12",
                "Id": "02.95010b4c0753df5d.204755",
                "Children": []
              }
            ]
          },
          {
            "DisplayName": "Soap_Dispenser-Bradley_Corp_Diplomat-6A00-11",
            "Id": "",
            "Children": [
              {
                "DisplayName": "Soap_Dispenser-Bradley_Corp_Diplomat-6A00-11",
                "Id": "02.95010b4c0753df5d.204397",
                "Children": []
              },
              {
                "DisplayName": "Soap_Dispenser-Bradley_Corp_Diplomat-6A00-11",
                "Id": "02.95010b4c0753df5d.204605",
                "Children": []
              }
            ]
          }
        ]
      }
    ]
  }
]
